export default "__VITE_ASSET__CQmf9inM__"